import { blockCategories } from '../../../categories';

export default function Popover(editor, opts = {}) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    opts = {
        category: blockCategories.basic,
        label: 'Popover',
        block: {},
        ...opts,
    };

    domComponents.addType('popover-trigger', {
        isComponent: (el) => el.dataset?.type === 'popover-trigger',

        model: {
            defaults: {
                tagName: 'div',
                draggable: ['popover'],
                droppable: true,
                editable: true,
                attributes: {
                    'data-type': 'popover-trigger',
                    class: 'sio-popover-trigger',
                },
                components: {
                    type: 'text',
                    content: 'Popover trigger',
                    editable: true,
                    droppable: false,
                    draggable: false,
                },
                label: 'Popover Trigger',
            },
        },
    });

    domComponents.addType('popover-box', {
        isComponent: (el) => el.dataset?.type === 'popover-box',

        model: {
            defaults: {
                tagName: 'div',
                draggable: ['popover'],
                droppable: true,
                editable: true,
                attributes: {
                    'data-type': 'popover-box',
                    class: 'sio-popover-box sio-popover-position-bottom',
                },
                components: {
                    type: 'text',
                    content: 'Popover content',
                    editable: true,
                    droppable: false,
                    draggable: false,
                },
                label: 'Popover Box',
            },
        },
    });

    domComponents.addType('popover', {
        isComponent: (el) => el.dataset?.type === 'popover',

        model: {
            defaults: {
                tagName: 'div',
                draggable: true,
                droppable: ['popover-trigger', 'popover-box'],
                attributes: {
                    'data-type': 'popover',
                    class: 'sio-popover',
                },
                label: 'Popover',
                traits: [
                    {
                        type: 'select',
                        label: 'Auslöser',
                        name: 'trigger',
                        options: [
                            {
                                name: 'Hover',
                                value: 'hover',
                            },
                            {
                                name: 'Klick',
                                value: 'click',
                            },
                        ],
                        default: 'hover',
                        changeProp: 1,
                    },
                    {
                        type: 'select',
                        label: 'Position',
                        name: 'position',
                        options: [
                            {
                                name: 'Oben',
                                value: 'top',
                            },
                            {
                                name: 'Unten',
                                value: 'bottom',
                            },
                            {
                                name: 'Rechts',
                                value: 'right',
                            },
                            {
                                name: 'Links',
                                value: 'left',
                            },
                        ],
                        default: 'bottom',
                        changeProp: 1,
                    },
                ],
                components: [
                    {
                        type: 'popover-trigger',
                    },
                    {
                        type: 'popover-box',
                    },
                ],
                style: {
                    position: 'relative',
                },
            },

            init() {
                this.on('change:position', this.updatePopoverPosition);
            },

            updatePopoverPosition() {
                const position = this.get('position') || 'bottom';
                const box = this.findType('popover-box')[0];

                if (!box) {
                    return;
                }

                box.removeClass([
                    'sio-popover-position-top',
                    'sio-popover-position-bottom',
                    'sio-popover-position-left',
                    'sio-popover-position-right',
                ]);

                box.addClass(`sio-popover-position-${position}`);
            },
        },
    });

    editor.Commands.add('popover:toggle', {
        run(editor, sender, options = {}) {
            const component = options.component || editor.getSelected();

            if (!component) return;

            if (component.get('type') !== 'popover') {
                return;
            }

            const el = component.getEl();

            if (!el) return;

            const box = el.querySelector(':scope > .sio-popover-box');

            if (!box) return;

            const isHidden = box.style.display === 'none';

            box.style.display = isHidden ? '' : 'none';

            component.set('popoverOpen', isHidden);
        },
    });

    editor.on('component:selected', (component) => {
        if (component.get('type') !== 'popover') {
            return;
        }

        const toolbar = component.get('toolbar') || [];

        const hasToggle = toolbar.some(
            (btn) => btn.command === 'popover:toggle'
        );

        if (hasToggle) return;

        component.set('toolbar', [
            ...toolbar,
            {
                attributes: {
                    class: 'fa fa-eye toolbar-icon',
                    title: 'Popover anzeigen / ausblenden',
                },
                command: 'popover:toggle',
                label: '',
            },
        ]);
    });

    blockManager.add('popover-block', {
        label: opts.label,
        category: opts.category,
        media: `<svg viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M4 4h16v12H4V4zm2 2v8h12V6H6zm-2 12h16v2H4v-2z"
            />
        </svg>`,
        content: {
            type: 'popover',
        },
        ...opts.block,
    });
}
